module.exports = __webpack_public_path__ + "img/technology1-ar.7f8989f4.png";